import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';

interface UploadedFileResponse {
  status: 'success';
  file_url: string;
}

export default function useUploadedFileApi() {
  const uploadFile = async (file: File): Promise<string> => {
    const token = await getLocalStorage('access_token');

    const formData = new FormData();
    formData.append('file', file);

    const response = await ChessRestClient.post<UploadedFileResponse>(
      '/inbox/uploaded_file',
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    if (response.data?.status !== 'success' || !response.data?.file_url) {
      throw new Error(response.data?.error ?? 'Upload failed');
    }

    return response.data.file_url;
  };

  return useMutation(uploadFile);
}
